import { c as _c } from "react/compiler-runtime";
import { SidePanelTabs } from "@components/sidepanel/sidepanel-tabs";
import { Box } from "@mui-wrapper";
import { useCallback, useMemo, useState } from "react";
/**
 * Component for displaying a sticky side panel with optional tabs and content.
 *
 * This component renders a sticky side panel that includes a header, optional tabs,
 * and either tab content or default content based on the presence of tabs.
 *
 * @returns JSX.Element
 */
export function StickySidePanelContainer(t0) {
  const $ = _c(20);
  const {
    header,
    tabs,
    defaultContent,
    selectedTab
  } = t0;
  const [activeTab, setActiveTab] = useState(selectedTab);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (_, newValue) => {
      setActiveTab(newValue);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleChange = t1;
  let t2;
  if ($[1] !== activeTab || $[2] !== tabs) {
    t2 = tabs?.find(t3 => {
      const {
        label
      } = t3;
      return label === activeTab;
    })?.content();
    $[1] = activeTab;
    $[2] = tabs;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedTabContent = t2;
  const t3 = header ? 2 : 0;
  let t4;
  if ($[4] !== t3) {
    t4 = {
      position: "sticky",
      top: 0,
      backgroundColor: "background.paper",
      zIndex: 1,
      pt: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== activeTab || $[7] !== header || $[8] !== tabs) {
    t5 = tabs && <Box sx={{
      mt: header ? 2 : 0
    }}><SidePanelTabs tabs={tabs} selectedTab={activeTab} handleChange={handleChange} /></Box>;
    $[6] = activeTab;
    $[7] = header;
    $[8] = tabs;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = defaultContent ? "12px" : "0";
  let t7;
  if ($[10] !== t6) {
    t7 = <Box sx={{
      borderBottom: 1,
      borderColor: "divider",
      mt: t6
    }} />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== header || $[13] !== t4 || $[14] !== t5 || $[15] !== t7) {
    t8 = <Box sx={t4}>{header}{t5}{t7}</Box>;
    $[12] = header;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = selectedTabContent || defaultContent;
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}